import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
function LinkOverlayComponent(props, ref) {
    const { isExternal = false, target, rel, className, children, component = 'a', ...rest } = props;
    const Component = component;
    return (_jsx(Component, { ref: ref, className: clsx('ui__link__overlay', className), css: {
            position: 'static',
            textDecoration: 'none',
            color: 'inherit',
            '&::before': {
                content: '""',
                cursor: 'inherit',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 0,
                width: '100%',
                height: '100%',
            },
        }, ...rest, rel: isExternal ? 'noopener noreferrer' : rel, target: isExternal ? '_blank' : target, children: children }));
}
/**
 * A component used to wrap and entire element in a link while staying semantic and accessible. Should be used with LinkOverlayContainer.
 */
export const LinkOverlay = React.forwardRef(LinkOverlayComponent);
